module.exports = __webpack_public_path__ + "static/media/sweater.530d7358.png";